// extracted by mini-css-extract-plugin
module.exports = {"tableTitle":"style__tableTitle__vJkhf"};